import getQuery from './utils';
import { objectToQueryParams } from 'utils/urlutils';
import viewTypes from 'constants/HelpCentreConstants';
import { GET_MY_ORDERS_REQUEST, GET_MY_ORDERS_REQUEST_PS2 } from 'fk-cp-common-components/actions/myOrdersActions';
import { GET_ISSUE_DETAILS_SUCCESS } from 'fk-cp-common-components/actions/trackIssueActions';
import { SET_VIEW_TYPE } from 'actions/viewType';
import { issueFaqActionsEnum } from 'actions/HelpCentreActions/issueFaqActions';
import { catalogActionsEnum } from 'actions/HelpCentreActions/catalogActions';
import { faqActionsEnum } from 'actions/HelpCentreActions/faqActions';
import { serviceTicketActionsEnum } from 'actions/HelpCentreActions/serviceTicketActions';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import { searchActionsEnum } from 'actions/HelpCentreActions/searchAction';
import get from 'lodash/get';
import { isNarrowIntentPage } from 'pages/HelpCentrePage/utils';
const HOME_TITLE = 'Help Centre';
const HOME_URL = '/helpcentre';
const defaultState = [
    {
        title: HOME_TITLE,
        url: HOME_URL
    }
];
const ORDERS_BREADCRUMB = {
    title: HOME_TITLE,
    url: `${HOME_URL}?view=${viewTypes.ORDERS}`
};
const INTENTS_BREADCRUMB = {
    title: HOME_TITLE,
    url: `${HOME_URL}?view=${viewTypes.INTENTS}`
};
const INCIDENTS_BREADCRUMB = {
    title: HOME_TITLE,
    url: `${HOME_URL}?view=${viewTypes.INCIDENTS}`
};
const INCIDENTS_LIST_BREADCRUMB = {
    title: 'Incidents',
    url: `${HOME_URL}/issues`
};
export default function breadCrumbs(state = defaultState, action = {
    type: null
}) {
    if (!ExecutionEnvironment.canUseDOM)
        return defaultState;
    const { pathname, search } = window.location;
    switch (action.type) {
        case searchActionsEnum.SEARCH_REQUEST:
            return [...defaultState, { title: 'Search Result' }];
        case GET_MY_ORDERS_REQUEST:
        case GET_MY_ORDERS_REQUEST_PS2:
            return isNarrowIntentPage(pathname) ? state : [ORDERS_BREADCRUMB];
        case issueFaqActionsEnum.STATIC_ISSUE_REQUEST:
            return [INTENTS_BREADCRUMB, { title: 'Non-Order Issues' }];
        case catalogActionsEnum.CATALOG_RESPONSE:
            return [...defaultState, { title: action.data.catalogName }];
        case catalogActionsEnum.SUB_CATALOG_RESPONSE:
            let query = search.split('&');
            query.length > 2 ? (query = `${query[0]}&${query[2]}`) : (query = search);
            return [
                ...defaultState,
                { title: state[1].title, url: `${pathname}${query}` },
                { title: action.data.catalogName }
            ];
        case faqActionsEnum.SELECT_FAQ:
            if (state[2] && state[2].title) {
                let query = search.split('&');
                query.length > 2 ? (query = `${query[0]}&${query[2]}`) : (query = search);
                return [
                    ...defaultState,
                    { title: state[1].title, url: `${pathname}${query}` },
                    { title: state[2].title, url: `${pathname}${search}` },
                    { title: action.title }
                ];
            }
            if (state[1] && state[1].title) {
                return [...defaultState, { title: state[1].title, url: `${pathname}${search}` }, { title: action.title }];
            }
            return state;
        case serviceTicketActionsEnum.SERVICE_TICKET_REQUEST:
            return [...defaultState, { title: 'Service Tickets' }];
        case serviceTicketActionsEnum.LOGIN_TO_VIEW:
            return [...defaultState];
        case issueFaqActionsEnum.ISSUEFAQ_SUCCESS:
            const result = get(action, ['data', 'result'], []);
            if (search.indexOf(`category=${viewTypes.NON_ORDER_ISSUE}`) !== -1) {
                return [
                    INTENTS_BREADCRUMB,
                    {
                        title: 'Non-Order Issues',
                        url: `${pathname}${objectToQueryParams(getQuery({}, viewTypes.NON_ORDER_ISSUE))}`
                    },
                    { title: result.length > 0 && get(result[0], ['htmlQuestion'], '') }
                ];
            }
            if (search.indexOf(`category=${viewTypes.ORDER_ISSUE}`) !== -1) {
                return [ORDERS_BREADCRUMB, { title: result.length > 0 && get(result[0], ['htmlQuestion'], '') }];
            }
            return state;
        case GET_ISSUE_DETAILS_SUCCESS:
            const title = get(action.data, [
                'trackIssueResponse',
                'customerIncidentDetail',
                'customerIncident',
                'issue',
                'subject'
            ]);
            return [
                ...state,
                {
                    title: title || 'Help with your Incident'
                }
            ];
        case SET_VIEW_TYPE:
            switch (action.data) {
                case viewTypes.INTENTS:
                    return [INTENTS_BREADCRUMB];
                case viewTypes.INCIDENTS:
                    return [INCIDENTS_BREADCRUMB];
                case viewTypes.INCIDENT_LIST:
                    return [INCIDENTS_BREADCRUMB, INCIDENTS_LIST_BREADCRUMB];
                case viewTypes.NARROW_INTENT:
                    return [
                        INTENTS_BREADCRUMB,
                        {
                            title: 'Help with your order' // todo_kj: title based on id?
                        }
                    ];
                default:
                    return state;
            }
            return state;
        default:
            return state;
    }
}
